var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "password tc" },
    [
      _c("h2", [_vm._v("请输入支付验证码")]),
      _c("p", [_vm._v("接收手机号码：" + _vm._s(_vm.infos.desensitizedPhone))]),
      _c("van-password-input", {
        attrs: {
          value: _vm.password,
          mask: false,
          focused: _vm.showKeyboard,
          gutter: "10px"
        },
        on: {
          focus: function($event) {
            _vm.showKeyboard = true
          }
        }
      }),
      _c("div", { staticClass: "get-code", on: { click: _vm.getCode } }, [
        _vm._v("重新获取 " + _vm._s(_vm.counts ? "(" + _vm.counts + "s)" : ""))
      ]),
      _c("van-number-keyboard", {
        attrs: { show: _vm.showKeyboard },
        on: {
          blur: function($event) {
            _vm.showKeyboard = false
          }
        },
        model: {
          value: _vm.password,
          callback: function($$v) {
            _vm.password = $$v
          },
          expression: "password"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }